// extracted by mini-css-extract-plugin
export default {"noResultsAlert":"no-results-alert-module__noResultsAlert--rFeyS"};